export default function HeroTabs() {
  const heroTabsWrapper = document.querySelectorAll<HTMLDivElement>(".js-tabs-wrapper");

  heroTabsWrapper.forEach((wrapper) => {
    const tabs = wrapper.querySelectorAll<HTMLButtonElement>(".js-tab-btn");
    const sections = wrapper.querySelectorAll<HTMLDivElement>(".js-tab-section");

    if (heroTabsWrapper && heroTabsWrapper && heroTabsWrapper.length > 0) {
      const handleClick = (index: number) => {
        tabs.forEach((tab: HTMLButtonElement, i: number) => {
          if (index === i) {
            tab.setAttribute("data-active", "true");
          } else {
            tab.setAttribute("data-active", "false");
          }
        });

        sections.forEach((section: HTMLDivElement, i: number) => {
          if (index === i) {
            section.setAttribute("data-active", "true");
          } else {
            section.setAttribute("data-active", "false");
          }
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => handleClick(index));
      });
    }
  });
}
